
























import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { Component, PropSync } from 'vue-property-decorator';

@Component
export default class MinCard extends mixins(DictMixin) {
  @PropSync('config') configSync!: any;
}
